module.exports = __webpack_public_path__ + "static/media/ClassdefinitionOverview.d90e1ba6.md";